import React, { useState } from 'react';
import { BsCheckLg, BsPencil, BsShieldPlus } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  HStack,
  Icon, IconButton,
  Input,
  VStack
} from '@chakra-ui/react';

import colors from '../../../../../../styles/theme/foundation/colors';
import RequirementTemplateBlueprintType from '../../../../../../types/RequirementTemplateBlueprintType';
import IconButtonMenu from '../../../../../IconButtonMenu';
import { shieldedRequirementsOptions } from '../../../../util/options';

const TemplateName = ({ name, children, align = 'center' }) => (
  <VStack alignItems={align} width="90%">
    <Box
      overflowWrap="anywhere"
      textStyle="bodyXxl500"
    >
      {name}
    </Box>
    {children}
  </VStack>
);

const TemplateBuilderListRequirementsBoxHeader = ({ blueprint }) => {
  const currentTemplate = useSelector(blueprint.selectCurrentRequirementTemplate);
  const dispatch = useDispatch();
  const [showError, setError] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const renderInputGroup = () => {
    if (currentTemplate.insuredId) {
      return (
        <TemplateName align="flex-start" name={currentTemplate.name}>
          <Box
            color={colors.greyScale['600']}
            overflowWrap="anywhere"
            textStyle="bodyLg500"
          >
            {currentTemplate.description}
          </Box>
        </TemplateName>
      );
    }

    if (isEditing === true) {
      return (
        <VStack width="90%">
          <Input
            _focus={{
              outline: 'none',
              backgroundColor: 'white',
              boxShadow: showError
                ? `inset 0 0 0 1px ${colors.error.primary['600']}`
                : `inset 0 0 0 1px ${colors.primaryScale['600']}`
            }}
            boxShadow={
                showError
                  ? `inset 0 0 0 1px ${colors.error.primary['600']}`
                  : `inset 0 0 0 1px ${colors.primaryScale['600']}`
              }
            defaultValue={currentTemplate.name}
            id="template-name"
            textAlign="center"
          />

          <IconButton
            aria-label="Save Template Name"
            borderRadius="sm"
            icon={<Icon as={BsCheckLg} />}
            isDisabled={submitting}
            size="xs"
            variant="accentSuccess"
            onClick={handleNameSubmit}
          />
        </VStack>
      );
    }

    return (

      <TemplateName name={currentTemplate.name}>

        <IconButton
          aria-label="Edit Template Name"
          borderRadius="sm"
          icon={<Icon as={BsPencil} />}
          size="xs"
          variant="accent"
          onClick={() => setIsEditing(true)}
        />
      </TemplateName>
    );
  };

  const handleNameSubmit = async () => {
    let templateName = document.querySelector('#template-name').value;
    if (showError) setError(false);

    if (!templateName.trim()) {
      templateName = 'Untitled';
    }

    if (templateName.length > 190 || templateName.length < 2) {
      setError(true);
      return;
    }

    setSubmitting(true);
    await dispatch(blueprint.updateRequirementTemplate(
      currentTemplate.id,
      { name: templateName }
    ));

    setIsEditing(false);
    setSubmitting(false);
  };

  return (
    <Box
      border="10px 10px 0 0"
      h="100%"
      height="10vh"
      layerStyle="partialPanelTop"
      maxH="100px"
      minH="95px"
      minW="552px"
      mr={4}
      p={6}
      w="100%"
    >
      <HStack direction="row" h="100%" justifyContent="center" spacing={2} w="100%">
        {renderInputGroup()}
        {/* <IconButtonMenu */}
        {/*  iconElement={<Icon as={BsShieldPlus} boxSize="21px" />} */}
        {/*  id={currentTemplate?.id} */}
        {/*  justifyContent="right" */}
        {/*  menuOptions={shieldedRequirementsOptions} */}
        {/*  variant="accentSuccess" */}
        {/* /> */}
      </HStack>
    </Box>
  );
};

TemplateBuilderListRequirementsBoxHeader.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default TemplateBuilderListRequirementsBoxHeader;
